export const ISTAT_MILANO = '015146';

export const ISTAT_MILANO_2 = '15146';
